import { createFileRoute } from '@tanstack/react-router';

import { CertificatesPage } from '@/features/talent/certificates-page';

export const Route = createFileRoute('/_app/me/work/certificates')({ component: CertificatesPage });
